/***
*
*   PLAN DISTRIBUTION
*   Pie chart showing distribution of organizations by plan
*
**********/

import { Card, Chart, usePlans } from 'components/lib';
import Style from './dashboard.tailwind.js';

// Fixed color palette - each plan gets a unique color by index
const PLAN_COLORS = [
  '#8B5CF6', // Purple
  '#10B981', // Green
  '#3B82F6', // Blue
  '#F59E0B', // Orange
  '#EF4444', // Red
  '#EC4899', // Pink
  '#14B8A6', // Teal
  '#6366F1', // Indigo
  '#84CC16', // Lime
  '#1F2937', // Gray
];

export function PlanDistribution(props) {
  const { data = [], loading } = props;
  const plans = usePlans();

  // Build a color map based on the data array order (ensures unique colors)
  const planColorMap = {};
  data.forEach((item, index) => {
    planColorMap[item.plan] = PLAN_COLORS[index % PLAN_COLORS.length];
  });

  // Calculate total for percentages
  const total = data.reduce((sum, item) => sum + item.count, 0);

  // Get color for a specific plan
  const getColorForPlan = (planKey) => {
    return planColorMap[planKey] || '#6B7280';
  };

  // Calculate percentage
  const getPercentage = (count) => {
    if (total === 0) return 0;
    return ((count / total) * 100).toFixed(1);
  };

  // Transform array data for chart
  const chartData = {
    labels: data.map(item => {
      const pct = getPercentage(item.count);
      return `${item.plan_name || item.plan} (${pct}%)`;
    }),
    datasets: [{
      data: data.map(item => item.count),
      backgroundColor: data.map(item => getColorForPlan(item.plan)),
      borderWidth: 2,
      borderColor: '#ffffff',
    }]
  };

  // Chart options with percentage display
  const chartOptions = {
    plugins: {
      tooltip: {
        callbacks: {
          label: function(context) {
            const value = context.raw;
            const pct = getPercentage(value);
            return `${value} organizations (${pct}%)`;
          }
        }
      },
      legend: {
        display: false
      }
    }
  };

  return (
    <Card title="Plan Distribution" loading={loading || plans.loading}>
      <div className={Style.chartContainer}>
        {total > 0 ? (
          <Chart
            type="pie"
            data={chartData}
            option={chartOptions}
            legend={true}
          />
        ) : (
          <div className={Style.noData}>No plan data available</div>
        )}
      </div>

      {/* Total Count */}
      {total > 0 && (
        <div className={Style.totalCount}>
          <span className={Style.totalLabel}>Total:</span>
          <span className={Style.totalValue}>{total} organizations</span>
        </div>
      )}
    </Card>
  );
}